<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Wyślij SMS
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-autocomplete
                    v-model="sendSmsUser"
                    :items="users.filter(user => user.phone)"
                    item-value="id"
                    item-text="email"
                    label="Użytkownik"
                >
                  <template v-slot:selection="data">
                    {{ data.item.email }} - {{ data.item.phone }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.email }} - {{ data.item.phone }}
                  </template>
                </v-autocomplete>
                <SendSms :user-id="sendSmsUser"></SendSms>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";
import SendSms from "@/components/SendSms.vue";

export default {
  name: 'ModalSendSms',
  components: {SendSms},
  mixins: [
  ],
  created() {
  },
  data: () => ({
    dialog: false,
    sendSmsUser: null,
    users: [],
    id: null,
  }),
  methods: {
    open(id) {
      this.id = id;
      this.dialog = true;
      this.getUsers();
    },
    getUsers() {
      api.get(`/api/companies/${this.id}/users`, {})
          .then((response) => {
            this.users = response.data.items;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać danych użytkowników.',
              error,
            });
          });
    },
  },
}
</script>

<style scoped></style>
